import { ethers } from "ethers";
import { ContractMethod } from "./Contract";

type Balance = string;

export type Contract = {
  address: string;
  decimals: number;
};

export type AdapterBalance = { name: string; balance: Balance };

export type ExecutionResponse = {
  success: boolean;
  functionName: ContractMethod;
  value: string;
  hash: string;
  params: ExecutionValueProps;
};

export type ExecutionValueProps = {
  args?: Array<string | number | undefined>;
  callValue?: string | number | undefined;
  blockTag?: number | "latest";
};

export type ExecutionParams = {
  args: Array<string | number | undefined>;
  callValue: string | number | undefined;
  blockTag?: number | "latest";
};

export interface User {
  signer: ethers.Signer;
  address: string;
}

export interface IAdapter {
  checkWallet(wallet: string): boolean;
  isConnected(): boolean;
  getAddress(): string;
  getBalances(): Promise<AdapterBalance[]>;

  connect(): Promise<User>;

  isSiteConnected(): Promise<boolean>;

  logout(): Promise<void>;

  onConnect(cb: () => void): void;

  execute(
    contractName: string,
    method: ContractMethod,
    values: ExecutionValueProps,
    isWrite?: boolean
  ): Promise<ExecutionResponse>;

  getBalanceOf(
    contractAddress: string,
    targetAddress?: string,
    blockTag?: number | "latest"
  ): Promise<AdapterBalance>;

  getCurrentBlockHeight(): Promise<string>;

  signMessage(msg: string): Promise<any>;

  waitForTransaction(transactionHash: string): Promise<"SUCCESS" | "FAILED">;
}

export const NON_SUCCESS_RESPONSE = { success: false, value: "", hash: "" };
